import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";

export const SourcePdfDialog = ({ projectId, onClose }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let u;
    api.get(`/projects/${projectId}/pdf`, { responseType: "blob" }).then(({ data }) => { u = URL.createObjectURL(data); setUrl(u); });
    return () => u && URL.revokeObjectURL(u);
  }, [projectId]);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-5xl bg-[#111827] border-slate-700 text-slate-100" data-testid="source-pdf-dialog">
        <DialogHeader><DialogTitle className="font-heading">Source drawing</DialogTitle></DialogHeader>
        <div className="h-[75vh] rounded-md overflow-hidden bg-[#0B0F19] grid place-items-center">
          {url ? <iframe title="source pdf" src={url} className="w-full h-full" data-testid="source-pdf-frame" /> : <Loader2 className="animate-spin text-cyan-400" />}
        </div>
      </DialogContent>
    </Dialog>
  );
};
